document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-qty-action]');
  if (!button) return;

  var inputId = button.getAttribute('data-target');
  var input = document.getElementById(inputId);
  if (!input) return;

  var current = parseInt(input.value || '1', 10);
  var min = parseInt(input.getAttribute('min') || '1', 10);
  var step = parseInt(input.getAttribute('step') || '1', 10);

  if (button.getAttribute('data-qty-action') === 'increase') {
    input.value = current + step;
  } else {
    input.value = Math.max(min, current - step);
  }

  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('DOMContentLoaded', function () {
  var updateHeaderState = function () {
    document.body.classList.toggle('el-scrolled', window.scrollY > 8);
  };

  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
});
